import { BaseComponent } from "../../../base/BaseComponent";
import React from "react";
import { Row, Col } from "antd";
import "./HowToBCA.less";

export default class HowToBCA extends BaseComponent {
  render() {
    this.initShorts();
    return (
      <div
        id={this.constants.Ids.HowItWorks}
        title={this.lang.HowItWorks}
        className="gx-mb-6"
      >
        <h1>{this.lang.HowItWorks}</h1>
        <Row className="howitworks">
          {this.state.hiwList.map((m, i) => {
            return (
              <Col key={i} xs={24} sm={12} md={6} className="gx-text-center">
                <div className="howbox clearfix">
                  {i == 3 ? null : (
                    <div className="arrow-how">
                      <img
                        src="/assets/images/curve-arrow-blu.svg"
                        className="img-responsive"
                        alt={this.lang.RegisterPara}
                      />
                    </div>
                  )}
                  <img src={m.icon} alt={m.alt} />
                  <h3>
                    <div>{m.number}</div>
                    {m.header}
                  </h3>
                  <p>{m.detail}</p>
                </div>
              </Col>
            );
          })}
        </Row>
        <div className="gx-text-center cta-btn gx-mb-4 shake-horizontal">
          <a href="#contact-us">
            {this.lang.ContactUs}&nbsp;{this.lang.Now}
          </a>
        </div>
      </div>
    );
  }

  constructor(props) {
    super(props);
    this.init();
  }

  init() {
    let list = [];
    list.push({
      icon: "/assets/images/clipboard.svg",
      alt: this.lang.ContactUs,
      header: this.lang.ContactUs,
      detail: this.lang.ContactUsPara,
      number: 1
    });
    list.push({
      icon: "/assets/images/phone.svg",
      alt: this.lang.ReceiveACall,
      header: this.lang.ReceiveACall,
      detail: this.lang.ReceiveACallPara,
      number: 2
    });
    list.push({
      icon: "/assets/images/question2.svg",
      alt: this.lang.GeneralGuidance,
      header: this.lang.GeneralGuidance,
      detail: this.lang.GeneralGuidancePara,
      number: 3
    });
    list.push({
      icon: "/assets/images/technical-support.svg",
      alt: this.lang.PostProjectAssistance,
      header: this.lang.PostProjectAssistance,
      detail: this.lang.PostProjectAssistancePara,
      number: 4
    });
    this.state = {
      hiwList: list
    };
  }
}
